import { Component } from "@angular/core";

@Component({
  selector: "app-no-access",
  templateUrl: "./no-access.component.html",
  styleUrls: ["./no-access.component.scss"],
  standalone: false,
})
export class NoAccessComponent {}
